// Lang And Currency
function changeSiteLanguage(langID, langCode) {

    var url = "/";
    var Catalogs = $("#PgCatalogs").val().split("/");
    var ctlgs = "";

    for (var i = 0; i < Catalogs.length; i++) {
        if (Catalogs[i].length > 0) {
            ctlgs += "&Cats=" + Catalogs[i];
        }
    }

    $.ajax({
        type: 'get',
        url: '/Home/ChangePageLang',
        data: 'PID=' + $("#PID").val() + "&PgType=" + $("#PgType").val() + "&AName=" + $("#AName").val() + "&CName=" + $("#CName").val() + "&langID=" + langID + ctlgs + "&langCode=" + langCode,
        success: function (dt) {
            window.parent.location.href = dt;
        }
    });

}

function ShowLangAreaForChange() {
    var userLang = navigator.language || navigator.userLanguage;

    if (userLang != null && userLang != undefined && userLang.length > 2) {
        userLang = userLang.substr(0, 2).toLowerCase();
    }

    $.ajax({
        type: "GET",
        url: "/" + $("#SmallLangCode").val() + "/p/Home/ShowLangSwitch",
        success: function (data) {

            if ($(".LangSelectionArea").length <= 0) {

                if (document.URL.indexOf("localhost") >= 0) {

                    $(".FixedHeader > .container:first").prepend(data);
                }
            }
            else if ($(".LangSelectionArea").hasClass("gizle")) {

                if (document.URL.indexOf("localhost") >= 0) {

                    $(".LangSelectionArea").show();
                }
            }
            else {
                $(".LangSelectionArea").hide();
            }
        }
    });
}

function ShowCurrencyForChange() {
    $.ajax({
        type: "GET",
        url: "/" + $("#SmallLangCode").val() + "/p/Home/ShowCurrencySwitch",
        success: function (data) {

            if ($(".CurrrencySelectionArea").length <= 0) {

                if ($(".AllowCurrencyChange").length > 0) {

                    $(".FixedHeader > .container:first").prepend(data);
                }

            } else if ($(".CurrrencySelectionArea").hasClass("gizle")) {

                if ($(".AllowCurrencyChange").length > 0) {

                    $(".CurrencySelectionArea").show();
                }


            } else {

                $(".CurrrencySelectionArea").hide();
            }

        }
    });

}
// Lang And Currency

function SetWindowSize() {
    $.ajax({
        type: "GET",
        url: "/" + $("#SmallLangCode").val() + "/p/User/SetUserWindowSize?u.Width=" + $(window).width() + "&u.Height=" + $(window).height(),
        cache: false,
        success: function (cdt) {

        }
    });

    if ($(window).width < 980) {
        $("#LoginRegisterModal .modal-content").css("background-image", "none");
        $("#LoginRegisterModal .modal-content").removeAttr("style");
    }
}

$.fn.exists = function () {
    return this.length !== 0;
};

var lastpos = -1;
var showTopLink = 100;
var UserValue;

function ToggleFooterMenu() {
    if ($(window).width() < 992) {
        $(".footerContactWrapper .footerMenu").live("click", function () {
            $(this).find("ul").slideToggle();
            $(this).find("span").toggleClass("open");
        });
    }
}

function TopLink() {
    $('.top_link').hide();
    $('.top_link').click(function () {
        $('html, body').animate({ scrollTop: 0 }, 'slow');
    });

    $(window).scroll(function () {
        if ($(window).width() > 767) {
            if ($('.top_link').length > 0) {

                if ($(window).scrollTop() > showTopLink) {
                    $('.top_link').fadeIn('slow');
                } else {
                    $('.top_link').fadeOut('slow');
                }
            }
        }
    });
}

function resizeend() {
    if (new Date() - rtime < delta) {
        setTimeout(resizeend, delta);
    } else {
        timeout = false;
        SetWindowSize();
    }
}

function PasswordShowHide() {

    $("#showpassword").click(function () {
        if ($("#login_Password").attr("type") == "password") {
            $("#login_Password").attr("type", "text");
        }
        else {
            $("#login_Password").attr("type", "password");
        }
    });

    $("#showpasswordreg").click(function () {
        if ($("#register_Password").attr("type") == "password") {
            $("#register_Password").attr("type", "text");
        }
        else {
            $("#register_Password").attr("type", "password");
        }
    });

    $("#showpasswordagain").click(function () {
        if ($("#register_ConfirmPassword").attr("type") == "password") {
            $("#register_ConfirmPassword").attr("type", "text");
        }
        else {
            $("#register_ConfirmPassword").attr("type", "password");
        }
    });

}

$(document).ready(function () {

    // Menü içi katalog özelleştirme bölümü
    //var link = document.querySelector('a[data-rel="624"]');

    //if (link) {
    //    link.innerHTML = "BLACK FRIDAY <br> <span class='font-weight-normal'> NET %40 / %60 İNDİRİM </span>";
    //}

    CountDown(new Date("Nov 26, 2024 14:00:00").getTime(), new Date("Nov 27, 2024 19:50:00").getTime());

    //$.fn.SetBootPag = function (_controller) {
    //    if (_controller == "NewCat") {
    //        //Ürün listesinde ise header box shadow gizle
    //        $(".fixed-menu").css("box-shadow", "unset");
    //    }
    //}

    // Hamburger Menu
    if ($(window).width() < 991) {
        $(document).on("click", ".sorsfont-menu", function () {
            $(".nav-menu").toggleClass("open");
            $(".backdrop").toggleClass("ShowBackdrop");
            $(".sorsfont-menu").toggleClass("sorsfont-menu-reversed");
        });

        $(document).on("click", ".ShowBackdrop, .mobile-times", function () {
            $(".nav-menu").removeClass("open");
            $(".backdrop").removeClass("ShowBackdrop");
            $(".sorsfont-menu").removeClass("sorsfont-menu-reversed");
        });
    }

    if ($(window).width() < 991) {
        $(document).on("click", ".search-button-mobile", function () {
            $(".header-mobile-search").toggleClass("open");
            $(".mobile-search-input").trigger("click");
        });
    }

    // Menu item special color
    if ($("nav#MainMenu > ul.Mainmenu > li > a[data-rel='409']").length > 0 && !isMobile(true)) {
        $("nav#MainMenu > ul.Mainmenu > li > a[data-rel='409']").css('color', '#c328e4');
    }

    $("a[data-rel='2']").css('display', 'none');

    TopLink();
    ToggleFooterMenu();
    PasswordShowHide()

    $('.carousel').not('.SBanner').carousel();

    $(".menu-info-button").on("click", function (e) {
        $("#info-sub").toggleClass("open");
    });

    $("body .backdrop").on("click", function (e) {
        HideOpenWindows();
        $("body").removeClass("LeftMenuOpen BackDropped");
        $("#MainMenu").removeClass("open");
        $("body").removeClass("BasketDropped");
        hideBasket();
    });

    $(document).on("focus click", "#register_Gsm", "#Phone2", function () {
        $(".telephoneCodeInInput").css("display", "block");
        $("#register_Gsm").css("padding-left", "30px");
        $("#Phone2").css("padding-left", "30px");
    });

    var rtime;
    var timeout = false;
    var delta = 500;

    $(window).resize(function () {
        rtime = new Date();
        if (timeout === false) {
            timeout = true;
            setTimeout(resizeend, delta);
        }

        setContentHeight();
    });

    if (window.location.hash == "#Rg" && isMobile(true)) {
        $('html, body').animate({
            scrollTop: $("#LineRg").offset().top + -80
        }, 500);
    }

    if (window.location.hash != undefined && document.URL.indexOf("Yardim") > 0) {
        var curHash = window.location.hash.replace("#", "");
        $("#helpMenu a[href$='" + curHash + "']").trigger("click");
    }

    if (window.location.hash == "#Lg" && isMobile(true)) {
        $('html, body').animate({
            scrollTop: $(".GeneralBreadCrumb:first").offset().top + -50
        }, 500);
    }

    $("body").on("submit", "#NewsLetterForm", function () {
        $form = $(this);
        $NewsLetterResult = $(".NewsLetterResult");

        $.ajax({
            type: $form.attr("method"),
            url: $form.attr("action"),
            data: $form.serialize(),
            dataType: "json",
            success: function (dt) {

                if (dt.Sonuc == true) {

                    //newsletter başarılı gtag
                    dataLayer.push({
                        'event': 'custom_event',
                        'event_category': 'newsletter',
                        'event_action': 'newsletter_success'
                    });

                    AlertObject = dt.JsonRs[0];

                    $(".formItem").hide();
                    $NewsLetterResult.show();
                    $NewsLetterResult.html(AlertObject);
                    $(".NewsletterFormHead").hide();
                    setTimeout(function () { $("#NewsletterPopup").modal("hide"); }, 3000);
                }
                else {
                    $NewsLetterResult.show();
                    if (dt.JsonRs != undefined && dt.JsonRs.length > 0) {
                        $NewsLetterResult.html(dt.JsonRs[0]);
                        $(".NewsletterFormHead").hide();
                    }
                    else if (dt.IslemSonucAciklama != null || dt.IslemSonucAciklama != "") {
                        $NewsLetterResult.html(dt.IslemSonucAciklama);
                        $(".NewsletterFormHead").hide();
                    }
                }
            },
            error: function (a) {

                //newsletter fail gtag
                dataLayer.push({
                    'event': 'custom_event',
                    'event_category': 'newsletter',
                    'event_action': 'newsletter_failed'
                });

                alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
            }
        });

        return false;
    });

    var utm_source = getQuery(window.location.href).utm_source;
    var utm_campaign = getQuery(window.location.href).utm_campaign;
    var utm_medium = getQuery(window.location.href).utm_medium;

    if ((utm_source != undefined && utm_source.length > 0) || (utm_campaign != undefined && utm_campaign.length > 0) || (utm_medium != undefined && utm_medium.length > 0)) {
        $.ajax({
            url: "/" + $("#SmallLangCode").val() + "/p/User/SetUtmParam",
            data: "utm_source=" + utm_source + "&utm_campaign=" + utm_campaign + "&utm_medium=" + utm_medium,
            type: "POST",
            cache: false
        });
    }
});

function CountDown(countDownStartDate, countDownEndDate) {
    var now = new Date().getTime();

    if (now < countDownStartDate || now > countDownEndDate)
        return false;

    var timeleft = countDownEndDate - now;

    var days = Math.floor(timeleft / (1000 * 60 * 60 * 24));
    var hours = Math.floor((timeleft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutes = Math.floor((timeleft % (1000 * 60 * 60)) / (1000 * 60));
    var text = "BLACK FRIDAY! YILIN EN BÜYÜK İNDİRİMİ İÇİN";


    if (window.innerWidth < 991) {

        document.getElementById('CountDownWrapper').innerHTML = "<div class='CountDown'><div class='countdown-first'></div><div class=''>" + "<b>" + text + "</b></div><div class='countdown-second'> <span>Son </span><b class='day'>" + days + "</b> <span>Gün </span><b class='hour'>" + hours + "</b><span> Saat </span><b class='minute'>" + minutes + "</b><span> Dakika</span></div></div>";
    }
    else {
        document.getElementById('CountDownWrapper').innerHTML = "<div class='CountDown'><div class='countdown-first'></div><div class=''><b>" + text + "</b></div><div class='countdown-second'> <span>Son </span><b class='day'>" + days + "</b> <span>Gün </span><b class='hour'>" + hours + "</b><span> Saat </span><b class='minute'>" + minutes + "</b><span> Dakika</span></div></div>";
    }

    // document.getElementById('CountDownWrapper').innerHTML = "<div class='CountDown'><div class='countdown-first'><span>Efsane Değil <b>GERÇEK</b> İndirimler Başladı!</span></div></div>";

    var countdownTimer = setInterval(function () {
        now = new Date().getTime();
        timeleft = countDownEndDate - now;

        days = Math.floor(timeleft / (1000 * 60 * 60 * 24));
        hours = Math.floor((timeleft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        minutes = Math.floor((timeleft % (1000 * 60 * 60)) / (1000 * 60));

        $("#CountDownWrapper .day").html(days);
        $("#CountDownWrapper .hour").html(hours);
        $("#CountDownWrapper .minute").html(minutes);

        if (timeleft <= 0) {
            clearInterval(countdownTimer);
            document.getElementById('CountDownWrapper').innerHTML = "";
        }

    }, 1000);
}

function removeLeadingZero(inputElement) {
    var value = inputElement.value;

    value = value.trim();

    if (value.length > 0 && value.charAt(0) === '0') {
        value = value.slice(1);
    }

    inputElement.value = value;
}
